import create from "zustand";
import { persist, devtools } from "zustand/middleware";

type Props = {
    auth: boolean;
    changeAuth: (value: boolean) => void;
};

export const authStore = create(
    devtools(
        persist<Props>(
            (set) => ({
                auth: false,
                changeAuth: (value) =>
                    set(() => ({
                        auth: value,
                    })),
            }),
            {
                name: "change-auth-user",
                getStorage: () => localStorage,
            }
        )
    )
);
